import { Table } from "react-bootstrap";
import SelectQuestTableRow from "./SelectQuestTableRow";

const SelectQuestTable = ({
  title,
  quests,
  selectedQuestIds,
  onToggle,
  onToggleAll,
}) => {
  const isAllSelected =
    quests.length > 0 && quests.every((q) => selectedQuestIds.includes(q.id));

  return (
    <div className="custom-table-container">
      <div
        className={`custom-table-wrapper select-student-table-scroll ${title ? "border-top-0 rounded-bottom" : ""}`}
      >
        <Table hover className="custom-table mb-0">
          <thead className="custom-table-head">
            <tr
              style={{
                backgroundColor: "#cfebff",
                color: "#495057",
                fontWeight: "500",
              }}
            >
              <th style={{ width: "60px", verticalAlign: "middle", padding: "12px 16px", paddingLeft: "30px" }}>
                <div
                  onClick={onToggleAll}
                  style={{ cursor: "pointer" }}
                >
                  <input
                    className="form-check-input m-0"
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={onToggleAll}
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                </div>
              </th>

              <th style={{ fontSize: "1.1rem" }}>
                {title}
              </th>
            </tr>
          </thead>

          <tbody>
            {!quests || quests.length === 0 ? (
              <tr>
                <td colSpan="2" style={{ textAlign: "center" }}>
                  No quests found
                </td>
              </tr>
            ) : (
              quests.map((quest) => (
                <SelectQuestTableRow
                  key={quest.id}
                  quest={quest}
                  isChecked={selectedQuestIds.includes(quest.id)}
                  toggleQuestCheck={() => onToggle(quest)}
                  type="select"
                />
              ))
            )}
          </tbody>
        </Table>


      </div>
    </div>
  );
};

export default SelectQuestTable;
